export default __webpack_public_path__ + "static/media/quizThumbnail.2f0aaaee.png";